// @ts-check
import { LBButton } from '@linearb/buzz';
import AppRouter from 'common/AppRouter';
import Icon from 'components/base/Icon';
import { useHistory } from 'react-router-dom';

const SettingsButton = ({ text = 'Configure', historyState = {} }) => {
  const history = useHistory();

  const onClick = () =>
    history.replace({
      pathname: AppRouter.PROJECTS_INVESTMENT_CARVING_CONFIG.path,
      state: { ...historyState }
    });

  return (
    <LBButton data-cy='btn-ra-settings' onClick={onClick}>
      <Icon color='white' name='Pencil' /> {text}
    </LBButton>
  );
};

export default SettingsButton;
